export enum CanvasObjectsEnum {
  table = 'table',
  object = 'object',
}
